<template>
    <comp-9-art-adherence :section="9" :page="60" :nextDisabled="nextDisabled">
        <p>
            There are a lot of reasons why people don’t take their ART regularly. Reasons like forgetting to take it, believing they’re fine, thinking they’re
            too busy, they're tired of taking it, or worrying about other people judging them for taking ART.
        </p>
        <p>
            On the other side, there are some downsides to not taking ART on a regular basis. Check all that apply to you.
        </p>
        <v-checkbox
            v-for="downside in artDownsides"
            :key="downside.id"
            :label="downside.text"
            :value="downside.id"
            v-model="selectedDownsides"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedDownsideResponse"></v-text-field>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedDownsides: [],
            selectedDownsideResponse: null
        };
    },
    computed: {
        artSelectedDownsides() {
            let artSelectedDownsides = map(filter(this.artDownsides, 'selected'), 'id');

            if (artSelectedDownsides) {
                return artSelectedDownsides;
            } else return [];
        },
        artSelectedDownsideResponse() {
            let userEnteredDownside = filter(filter(this.artDownsides, 'selected'), 'userEntered');

            if (userEnteredDownside.length > 0) {
                return userEnteredDownside[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.artDownsides, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        artDownsides: sync('section9/artIrregularDownsides')
    },
    methods: {
        nextDisabled() {
            if (this.selectedDownsides.length === 0 || (this.showManualResponse && !this.selectedDownsideResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedDownsides() {
            forEach(this.artDownsides, o => {
                if (this.selectedDownsides.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedDownsideResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedDownsideResponse() {
            forEach(this.artDownsides, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedDownsideResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedDownsides = this.artSelectedDownsides;
        this.selectedDownsideResponse = this.artSelectedDownsideResponse;
    }
};
</script>
